/**
 * Recommandations de compétences : ce que la fiche d'un membre doit afficher.
 *
 * Le membre recommandé décide : une recommandation reste « en attente » tant
 * qu'il ne l'a pas acceptée (sauf s'il a choisi d'accepter d'office), et
 * seules les acceptées sont publiques et comptées.
 */

export const MODES_RECOMMANDATION = ['ask', 'auto', 'none'];

/**
 * Index des recommandations par compétence (skills.id), tel que la fiche l'affiche.
 *
 * @param {{skills?: Array, endorsements?: Array}} profil - Rendu de getEndorsementsProfile
 * @returns {Object<number, {peoplesSkillId: number, count: number, mine: string, auteurs: Array}>}
 */
export function indexerRecommandations(profil) {
    const index = {};
    for (const s of profil?.skills || []) {
        if (!s.skillId) continue;
        // Une même compétence peut apparaître sous plusieurs métiers : on garde la première ligne et on cumule
        const existant = index[s.skillId];
        if (existant) {
            existant.count += s.endorsementCount || 0;
            if (!existant.mine && s.mine) existant.mine = s.mine;
            continue;
        }
        index[s.skillId] = {
            peoplesSkillId: s.peoplesSkillId,
            count: s.endorsementCount || 0,
            mine: s.mine || '',
            auteurs: []
        };
    }
    for (const e of profil?.endorsements || []) {
        if (index[e.skillId]) index[e.skillId].auteurs.push(e);
    }
    return index;
}

/**
 * Que montrer à côté d'une compétence ?
 *
 * @returns {'hidden'|'available'|'pending'|'accepted'}
 *  - hidden : visiteur non connecté, propriétaire, membre qui n'en reçoit pas, ou recommandation refusée
 *             (on ne dit pas à l'auteur qu'elle a été refusée)
 *  - available : « Recommander »
 *  - pending : recommandation envoyée, en attente de la décision du membre
 *  - accepted : « Vous recommandez » (elle est publique)
 */
export function etatRecommander({ mode, mine, estProprietaire, connecte }) {
    if (estProprietaire || !connecte) return 'hidden';
    if (mine === 'accepted') return 'accepted';
    if (mine === 'pending') return 'pending';
    if (mine === 'declined') return 'hidden';
    if (mode === 'none') return 'hidden';
    return 'available';
}
